import { render, staticRenderFns } from "./home-fleet.vue?vue&type=template&id=96abb020&scoped=true"
var script = {}
import style0 from "./home-fleet.vue?vue&type=style&index=0&id=96abb020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96abb020",
  null
  
)

export default component.exports